/**
 * Converts an expiry month number to a string
 *
 * @param brand The brand to convert
 */
export const expiryMonthNumberToString = (month: number): string => {
  return ("0" + month).slice(-2);
};